import { AvatarProps } from '@systemeio/components'
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts'
import { UserInterface } from 'shared/types/user-interface'

/**
 * Name props for the avatar of the account the dashboard currently acts as, mirroring the entry
 * the subaccount selector marks as selected. The navbar avatar and the selector rows must resolve
 * initials from the same source, otherwise the same account renders different initials and,
 * since the avatar color seed is the initials, a different color too.
 *
 * Accounts outside a subaccount tree have no account-level display name, so they keep falling back
 * to the person's first and last name.
 */
export const getAccountAvatarName = (
  user: UserInterface,
): Pick<AvatarProps, 'displayName' | 'firstName' | 'lastName'> => {
  const displayName =
    user.mainUser && hasSubAccounts(user)
      ? (user.subaccounts.find(({ user: { id } }) => id === user.id)?.displayName ??
        user.mainUser.displayName)
      : undefined

  if (displayName) return { displayName }

  return {
    firstName: user.firstName ?? undefined,
    lastName: user.lastName ?? undefined,
  }
}
